
import { Component, Vue } from 'vue-property-decorator'
import { ENVIRONMENT } from '@/commons/configuration'

@Component
export default class LoginPage extends Vue {
    created (): void {
        document.title = this.$tc('metadata.frontPage')
    }

    loginHandler (): void {
        window.location.href = ENVIRONMENT.taraUrl
    }

    isInMaintenanceMode (): boolean {
        return ENVIRONMENT.isInMaintenanceMode
    }

    isNoticeActive (): boolean {
        return ENVIRONMENT.isNoticeActive
    }
}
